import { IPropertiesString } from "../containers/ProductViewPage/types";

export const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
export const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
export const imagePath = process.env.REACT_APP_IMAGE_PATH;

export const propertiesKeys: IPropertiesString[] = Object.values(IPropertiesString);
